export default {
  methods:{
    errorHandle(error = {}){
      this.$message({
        type:"error",
        message: error.desc || error.message || ''
      })
    },
    warningHandle(warning = {}){
      this.$message({
        type:"warning",
        message:warning.desc || warning.message || ''
      })
    },
    successHandle(success = {}){
      this.$message({
        type:"success",
        message:success.desc || success.message || ''
      })
    }
  }
}
